import { Row } from 'antd'
import { MemberProps } from 'app/components/Core/convention'
import KAddressInput from 'app/components/Modules/Form/KAddressInput'
import KForm from 'app/components/Modules/Form/KForm'
import KInputText from 'app/components/Modules/Form/KInputText'
import KNestedFields from 'app/components/Modules/Form/KNestedFields'
import KSelect from 'app/components/Modules/Form/KSelect'
import KCol from 'app/components/UI-Elements/Layout/KCol'
import { KFormProps, RecordType } from 'app/constants/GlobalTypes'
import { ToolBox } from 'app/lib/hooks/toolBox'
import { useRestriction } from 'app/lib/hooks/useRestriction'
import { attributeNames } from 'app/lib/utils/customer-address'
import { useMemo } from 'react'

const InvoiceForm: React.FC<MemberProps<ICustomer, KFormProps<ICustomer>>> = ({
  member,
  props = {}
}) => {
  const { restricted } = useRestriction({ allowFor: ['admin'] })
  const { smartTranslation } = ToolBox.useString()

  const DeliveryMethodOptions = useMemo(
    () => [
      {
        label: smartTranslation({
          recordType: RecordType.customer,
          id: 'email'
        }),
        value: 'email'
      },
      {
        label: smartTranslation({
          recordType: RecordType.customer,
          id: 'post'
        }),
        value: 'post'
      }
    ],
    []
  )

  const payloadModifier = (values: ICustomer) => ({
    ...values,
    billing_address: {
      ...values.billing_address,
      address: values.billing_address.address1 || values.billing_address.address
    }
  })

  return (
    <KForm
      recordId={member?.id}
      recordType={RecordType.customer}
      layout="vertical"
      hideSubmit={restricted}
      forceAction="update"
      payloadModifier={payloadModifier}
      {...props}>
      <fieldset disabled={restricted}>
        <Row gutter={[24, 0]}>
          <KCol xs={24} md={12}>
            <KNestedFields as={RecordType.billing_address}>
              <Row gutter={[24, 0]}>
                <KCol xs={24} md={12}>
                  <KInputText name="recipient_name" />
                </KCol>
                <KCol xs={24} md={12}>
                  <KInputText name="email" rules={[{ type: 'email' }]} />
                </KCol>
                <KCol span={24}>
                  <KAddressInput name="address_summary" names={attributeNames} />
                </KCol>
              </Row>
            </KNestedFields>
          </KCol>
          <KCol xs={24} md={12}>
            <Row gutter={[24, 0]}>
              <KCol span={12}>
                <KInputText
                  hasFeedback={false}
                  name="payment_deadline"
                  addonAfter={smartTranslation({
                    recordType: RecordType.customer,
                    id: 'days'
                  })}
                  disabled
                />
              </KCol>
              <KCol span={12}>
                <KInputText hasFeedback={false} name="vat_number" />
              </KCol>
            </Row>
            <KSelect
              selectValueBy="value"
              optionLabelProp="label"
              recordType={RecordType.customer}
              options={DeliveryMethodOptions}
              name="invoice_delivery_method"
              disabled={restricted}
            />
          </KCol>
        </Row>
      </fieldset>
    </KForm>
  )
}

export default InvoiceForm
